/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../../connect/v2/common/money';
import './credit_line_statement';
import '../../connect/v2/resources/address';
import './credit_line_rewards';
import './credit_limit_adjustment';
import '../../capital/plan/models';
import './credit_limit_adjustment_offer';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "corporate_card": {
        "nested": {
          "resources": {
            "nested": {
              "CreditLine": {
                "fields": {
                  "id": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "creditLimitMoney": {
                    "type": "squareup.connect.v2.common.Money",
                    "id": 2,
                    "rule": "optional"
                  },
                  "balanceSummary": {
                    "type": "squareup.corporate_card.resources.CreditLine.BalanceSummary",
                    "id": 9,
                    "rule": "optional"
                  },
                  "latestStatement": {
                    "type": "squareup.corporate_card.resources.CreditLineStatement",
                    "id": 10,
                    "rule": "optional"
                  },
                  "pendingStatement": {
                    "type": "squareup.corporate_card.resources.CreditLineStatement",
                    "id": 11,
                    "rule": "optional"
                  },
                  "holdRateBps": {
                    "type": "int32",
                    "id": 12,
                    "rule": "optional"
                  },
                  "aprBps": {
                    "type": "int32",
                    "id": 17,
                    "rule": "optional"
                  },
                  "autopaySettings": {
                    "type": "squareup.corporate_card.resources.CreditLine.AutopaySettings",
                    "id": 13,
                    "rule": "optional"
                  },
                  "paymentAccounts": {
                    "type": "squareup.corporate_card.resources.CreditLine.PaymentAccount",
                    "id": 14,
                    "rule": "repeated"
                  },
                  "gracePeriodActive": {
                    "type": "bool",
                    "id": 15,
                    "rule": "optional"
                  },
                  "payerEmailAddress": {
                    "type": "string",
                    "id": 16,
                    "rule": "optional"
                  },
                  "businessAddress": {
                    "type": "squareup.connect.v2.resources.Address",
                    "id": 18,
                    "rule": "optional"
                  },
                  "rewards": {
                    "type": "squareup.corporate_card.resources.CreditLineRewards",
                    "id": 19,
                    "rule": "optional"
                  },
                  "enabledFeatures": {
                    "type": "string",
                    "id": 20,
                    "rule": "repeated"
                  },
                  "createdAt": {
                    "type": "string",
                    "id": 7,
                    "rule": "optional"
                  },
                  "updatedAt": {
                    "type": "string",
                    "id": 8,
                    "rule": "optional"
                  },
                  "pendingPaymentAmountThresholdReached": {
                    "type": "bool",
                    "id": 21,
                    "rule": "optional"
                  },
                  "financialDisclosures": {
                    "type": "squareup.corporate_card.resources.CreditLine.SignedFinanceDisclosure",
                    "id": 22,
                    "rule": "repeated"
                  },
                  "businessDisplayName": {
                    "type": "string",
                    "id": 23,
                    "rule": "optional"
                  },
                  "token": {
                    "type": "string",
                    "id": 24,
                    "rule": "optional"
                  },
                  "platformType": {
                    "type": "squareup.corporate_card.resources.CreditLine.PlatformType",
                    "id": 25,
                    "rule": "optional"
                  },
                  "creditLimitAdjustments": {
                    "type": "squareup.corporate_card.resources.CreditLimitAdjustment",
                    "id": 27,
                    "rule": "repeated"
                  },
                  "minPayBps": {
                    "type": "int32",
                    "id": 28,
                    "rule": "optional"
                  },
                  "interestRateBps": {
                    "type": "int32",
                    "id": 29,
                    "rule": "optional"
                  },
                  "productName": {
                    "type": "string",
                    "id": 30,
                    "rule": "optional"
                  },
                  "closedAt": {
                    "type": "string",
                    "id": 31,
                    "rule": "optional"
                  },
                  "planStatus": {
                    "type": "squareup.capital.plan.models.Plan.Status",
                    "id": 32,
                    "rule": "optional"
                  },
                  "daysPastDue": {
                    "type": "int32",
                    "id": 33,
                    "rule": "optional"
                  },
                  "servicingStatus": {
                    "type": "string",
                    "id": 34,
                    "rule": "optional"
                  },
                  "creditLimitAdjustmentIncreaseOffer": {
                    "type": "squareup.corporate_card.resources.CreditLimitAdjustmentOffer",
                    "id": 35,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "BalanceSummary": {
                    "fields": {
                      "totalBalanceMoney": {
                        "type": "squareup.connect.v2.common.Money",
                        "id": 1,
                        "rule": "optional"
                      },
                      "currentMonthBalanceMoney": {
                        "type": "squareup.connect.v2.common.Money",
                        "id": 2,
                        "rule": "optional"
                      },
                      "statementBalanceMoney": {
                        "type": "squareup.connect.v2.common.Money",
                        "id": 3,
                        "rule": "optional"
                      },
                      "minimumPaymentBalanceMoney": {
                        "type": "squareup.connect.v2.common.Money",
                        "id": 4,
                        "rule": "optional"
                      },
                      "pastDueBalanceMoney": {
                        "type": "squareup.connect.v2.common.Money",
                        "id": 5,
                        "rule": "optional"
                      },
                      "availableBalanceMoney": {
                        "type": "squareup.connect.v2.common.Money",
                        "id": 6,
                        "rule": "optional"
                      },
                      "outstandingInterestBalanceMoney": {
                        "type": "squareup.connect.v2.common.Money",
                        "id": 7,
                        "rule": "optional"
                      },
                      "outstandingPrincipalBalanceMoney": {
                        "type": "squareup.connect.v2.common.Money",
                        "id": 8,
                        "rule": "optional"
                      }
                    }
                  },
                  "AutopaySettings": {
                    "fields": {
                      "enabled": {
                        "type": "bool",
                        "id": 1,
                        "rule": "optional"
                      },
                      "paymentAmountType": {
                        "type": "squareup.corporate_card.resources.CreditLine.AutopaySettings.PaymentAmountType",
                        "id": 2,
                        "rule": "optional"
                      },
                      "paymentAmount": {
                        "type": "squareup.connect.v2.common.Money",
                        "id": 3,
                        "rule": "optional"
                      },
                      "nextPaymentDate": {
                        "type": "string",
                        "id": 4,
                        "rule": "optional"
                      }
                    },
                    "nested": {
                      "PaymentAmountType": {
                        "values": {
                          "PAT_DO_NOT_USE": 0,
                          "STATEMENT_AMOUNT": 1,
                          "MIN_PAYMENT": 2
                        }
                      }
                    }
                  },
                  "PaymentAccount": {
                    "fields": {
                      "isPrimary": {
                        "type": "bool",
                        "id": 1,
                        "rule": "optional"
                      },
                      "bankInstitutionName": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      },
                      "bankAccountNumberSuffix": {
                        "type": "string",
                        "id": 3,
                        "rule": "optional"
                      },
                      "token": {
                        "type": "string",
                        "id": 4,
                        "rule": "optional"
                      },
                      "accountType": {
                        "type": "squareup.corporate_card.resources.CreditLine.PaymentAccount.AccountType",
                        "id": 5,
                        "rule": "optional"
                      }
                    },
                    "nested": {
                      "AccountType": {
                        "values": {
                          "AT_DO_NOT_USE": 0,
                          "SQUARE_CHECKING": 1,
                          "EXTERNAL_BANK": 2
                        }
                      }
                    }
                  },
                  "SignedFinanceDisclosure": {
                    "values": {
                      "CL_SFD_DO_NOT_USE": 0,
                      "CALIFORNIA_FINANCE_DISCLOSURE": 1,
                      "NEW_YORK_FINANCE_DISCLOSURE": 2,
                      "FLORIDA_FINANCE_DISCLOSURE": 3,
                      "GEORGIA_FINANCE_DISCLOSURE": 4,
                      "KANSAS_FINANCE_DISCLOSURE": 5,
                      "UTAH_FINANCE_DISCLOSURE": 6
                    }
                  },
                  "PlatformType": {
                    "values": {
                      "PT_DO_NOT_USE": 0,
                      "INTERNAL": 1,
                      "PEACH": 2
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.corporate_card?.nested?.resources?.nested?.CreditLine && !$root.nested?.squareup?.nested?.corporate_card?.nested?.resources?.nested?.CreditLine?.nested?.BalanceSummary && !$root.nested?.squareup?.nested?.corporate_card?.nested?.resources?.nested?.CreditLine?.nested?.AutopaySettings && !$root.nested?.squareup?.nested?.corporate_card?.nested?.resources?.nested?.CreditLine?.nested?.AutopaySettings?.nested?.PaymentAmountType && !$root.nested?.squareup?.nested?.corporate_card?.nested?.resources?.nested?.CreditLine?.nested?.PaymentAccount && !$root.nested?.squareup?.nested?.corporate_card?.nested?.resources?.nested?.CreditLine?.nested?.PaymentAccount?.nested?.AccountType && !$root.nested?.squareup?.nested?.corporate_card?.nested?.resources?.nested?.CreditLine?.nested?.SignedFinanceDisclosure && !$root.nested?.squareup?.nested?.corporate_card?.nested?.resources?.nested?.CreditLine?.nested?.PlatformType) {
  $root.addJSON(jsonData);
}

/**
 * --
 * @desc A credit line
 * --
 *
 * SOURCE CreditLine @ squareup/corporate_card/resources/credit_line.proto at 18:1
 */
export const CreditLine = $root.lookupType('squareup.corporate_card.resources.CreditLine');
fixType(CreditLine, {
  token: {
    required: true
  }
});
Builder.createAndAttachToType(CreditLine);
/**
 * SOURCE BalanceSummary @ squareup/corporate_card/resources/credit_line.proto at 20:3
 */
CreditLine.BalanceSummary = $root.lookupType('squareup.corporate_card.resources.CreditLine.BalanceSummary');
fixType(CreditLine.BalanceSummary);
Builder.createAndAttachToType(CreditLine.BalanceSummary);
/**
 * SOURCE AutopaySettings @ squareup/corporate_card/resources/credit_line.proto at 62:3
 */
CreditLine.AutopaySettings = $root.lookupType('squareup.corporate_card.resources.CreditLine.AutopaySettings');
fixType(CreditLine.AutopaySettings);
Builder.createAndAttachToType(CreditLine.AutopaySettings);
/**
 * SOURCE PaymentAmountType @ squareup/corporate_card/resources/credit_line.proto at 63:5
 */
CreditLine.AutopaySettings.PaymentAmountType = $root.lookupEnum('squareup.corporate_card.resources.CreditLine.AutopaySettings.PaymentAmountType').values;
/**
 * SOURCE PaymentAccount @ squareup/corporate_card/resources/credit_line.proto at 98:3
 */
CreditLine.PaymentAccount = $root.lookupType('squareup.corporate_card.resources.CreditLine.PaymentAccount');
fixType(CreditLine.PaymentAccount, {
  token: {
    required: true
  },
  accountType: {
    required: true
  }
});
Builder.createAndAttachToType(CreditLine.PaymentAccount);
/**
 * SOURCE AccountType @ squareup/corporate_card/resources/credit_line.proto at 99:5
 */
CreditLine.PaymentAccount.AccountType = $root.lookupEnum('squareup.corporate_card.resources.CreditLine.PaymentAccount.AccountType').values;
/**
 * SOURCE SignedFinanceDisclosure @ squareup/corporate_card/resources/credit_line.proto at 228:3
 */
CreditLine.SignedFinanceDisclosure = $root.lookupEnum('squareup.corporate_card.resources.CreditLine.SignedFinanceDisclosure').values;
/**
 * SOURCE PlatformType @ squareup/corporate_card/resources/credit_line.proto at 278:3
 */
CreditLine.PlatformType = $root.lookupEnum('squareup.corporate_card.resources.CreditLine.PlatformType').values;